import { render } from "./Login.layout.vue?vue&type=template&id=19c1ba19&scoped=true"
const script = {}

import "./Login.layout.vue?vue&type=style&index=0&id=19c1ba19&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/plus.centrodeglaucoma.com/darmin-plus/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19c1ba19"]])

export default __exports__